import { crypto } from "../crypto.js";

type Clip = {
  x: number;
  y: number;
  width: number;
  height: number;
  drawing_scale: string | null;
  drawing_offset: { x: number; y: number } | null;
}

type LocationParams = {
  id?: string;
  group_id: string;
  document_id: string;
  index?: number;
  type?: 'pin',
  category?: string | null;
  clip?: Clip | null;
  position: { x: number; y: number };
  page_id: string;
  record_type?: 'item' | 'collection' | 'type' | 'document_note';
  record_id: string,
  representation?: string;
  shape?: string;
  symbol?: string;
  scale_reference?: 'screen_space' | 'paper_space';
  size?: number;
  color_override?: string | null;
  transform?: object | null;
  ignore_for_auto_count?: boolean;
};

type LocationFilter = {
  operator: "is_equal_to" | "is_not_equal_to",
  value: string,
}

function createClip({
  x,
  y,
  width,
  height,
  drawing_scale = null,
  drawing_offset = { x: 0, y: 0 }
}: Clip) {
  const clip = {
    x,
    y,
    width,
    height,
    drawing_scale,
    drawing_offset,
  } as Clip;

  return clip;
}

function createLocation({
  id = crypto.randomUUID(),
  group_id,
  document_id,
  index = 0,
  type = 'pin',
  category = null,
  clip = null,
  position,
  page_id,
  record_type = 'item',
  record_id,
  representation = 'mark_in_shape',
  shape = 'default',
  symbol = 'default',
  scale_reference = 'screen_space',
  size = 10,
  color_override = null,
  transform = null,
  ignore_for_auto_count = false,
}: LocationParams,
  locationFilter: LocationFilter | null = null
) {
  const loc = {
    id,
    group_id,
    document_id,
    index,
    type,
    category,
    clip,
    position,
    page_id,
    record_type,
    record_id,
    representation,
    shape,
    symbol,
    scale_reference,
    size,
    color_override,
    transform,
    ignore_for_auto_count,
  } as LocationParams;

  if (locationFilter?.operator === "is_equal_to" && !category) {
    loc.category = locationFilter.value;
  }

  return loc;
}

interface Point {
  x: number;
  y: number;
}

export { createLocation, createClip };
